import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Ticket, X } from "lucide-react";

const KEY = "sr_coupon_dismissed";

export const CouponPopup = ({ onClaim }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return undefined;
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const close = () => { sessionStorage.setItem(KEY, "1"); setShow(false); };
  const claim = () => { close(); onClaim(); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="coupon-popup" role="status"
          initial={{ opacity: 0, y: 40, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 30 }}
          transition={{ type: "spring", stiffness: 260, damping: 24 }}
          className="fixed z-[55] bottom-4 left-4 right-4 sm:right-auto sm:bottom-6 sm:left-6 sm:w-[370px]">
          <div className="relative glass rounded-3xl p-4 pr-10 flex items-center gap-4 glow-pink border-[#FF2A8D]/40">
            <div className="relative shrink-0 w-14 h-14 rounded-2xl bg-[#FF2A8D] grid place-items-center">
              <Ticket size={26} />
              <span className="absolute -top-1.5 -right-1.5 w-3.5 h-3.5 rounded-full bg-[#5B95D6] animate-ping" />
              <span className="absolute -top-1.5 -right-1.5 w-3.5 h-3.5 rounded-full bg-[#5B95D6]" />
            </div>
            <div className="min-w-0">
              <p className="font-display font-extrabold text-lg leading-tight whitespace-nowrap">$10 off your test</p>
              <p className="text-xs text-slate-300 mt-0.5">Coupon included when you book — plus $10 back after.</p>
              <button data-testid="coupon-claim-btn" onClick={claim}
                className="mt-2 text-sm font-semibold text-[#FF54A5] hover:text-white transition-colors">Claim & book →</button>
            </div>
            <button data-testid="coupon-close-btn" onClick={close} aria-label="Dismiss coupon"
              className="absolute top-2.5 right-2.5 p-1.5 rounded-full text-slate-400 hover:text-white hover:bg-white/10"><X size={16} /></button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
